import BaseCtrl from 'edge/platform/base/BaseCtrl';
import _ from 'lodash';

const fn = ($scope, claimViewModel) => {
    const ctrl = Object.create(BaseCtrl);
    let lossCauseTypesArray;
    ctrl.init = () => {
        $scope.claimVm = claimViewModel();
        lossCauseTypesArray = $scope.claimVm.lossCause.value.typelist.codes;
    };

    ctrl.selectLossCause = (clickedTileCode) => {
        $scope.claimVm.lossCause.value = _.find(lossCauseTypesArray, (cause) => {
            return cause.code === clickedTileCode;
        });
    };

    ctrl.isCollisionSelected = () => {
        return !!_.find($scope.fnol.collisionTypeCodes, {
            'code': $scope.claimVm.lossCause.value.code
        });
    };

    ctrl.isTheftSelected = () => {
        return $scope.claimVm.lossCause.value.code === 'theftentire' || $scope.claimVm.lossCause.value.code === 'theftparts';
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claimViewModel'];

export default fn;